<template>
  <div class="kehuinfo">
    <div class="kehuli">
      <div class="liHead">
        <img :src="datas.avatar" />
      </div>
      <div class="liText">
        <div>{{ datas.nickname }}</div>
      </div>
      <span
        class="lookNum tag-read"
        @click="copy"
        :data-clipboard-text="datas.nickname"
        >复制微信名<i style="opacity: 0;display: block;width: 0;height: 0;">{{
          datas.nickname
        }}</i></span
      >
    </div>
    <div class="kehuinfo_main">
      <div class="main_title">看了的文章</div>
      <div class="main_ul">
        <div class="li" v-for="(item, index) in liList" :key="index">
          <div class="li_l">
            <div class="lil_title">
              {{ item.title }}
            </div>
            <div class="lil_text">
              看了<span>{{ item.view }}</span
              >次 {{ diffTime(item.add_time * 1000) }}
            </div>
          </div>
          <div class="li_r">
            <img :src="item.image_input" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@assets/css/kehu.css";
import { Toast } from "vant";
import {
  getShare,
  getClientListNew,
  getNumberViewsTodayNew
} from "@api/public";
import { cookie } from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
let vm = null;
import { getCustomerDetails } from "@api/lcapi";
export default {
  name: "kehuInfo",
  components: {},
  props: {},
  data: function() {
    return {
      datas: {},
      quanxainDialog: false,
      numberViewsToday: {},
      clientList: [],
      page: 1,
      liList: []
    };
  },
  created() {
    vm = this;
  },
  watch: {},
  mounted: function() {
    vm.setOpenShare();
    let datas = {
      avatar: this.$route.query.avatar,
      nickname: this.$route.query.name,
      id: this.$route.query.id
    };
    this.datas = datas;
    vm.getNumberViewsTodayNew();
    vm.getClientListNew();
    this.getCustomerDetails(this.$route.query.id);
  },
  computed: {
    diffTime() {
      return function(diffValue) {
        let minute = 60000;
        let hour = minute * 60;
        let day = hour * 24;
        let month = day * 30;

        let nowTime = new Date().getTime(); //获取当前时间戳
        let ShiJianCha = nowTime - diffValue;

        let monthC = ShiJianCha / month;
        let weekC = ShiJianCha / (7 * day);
        let dayC = ShiJianCha / day;
        let hourC = ShiJianCha / hour;
        let minC = ShiJianCha / minute;
        let res = "";

        if (monthC >= 12) {
          let oldTime = nowTime - diffValue; // 获取记录的时间戳
          let date = new Date(oldTime);
          res =
            date.getFullYear() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            date.getDate();
        } else if (monthC >= 1) {
          res = parseInt(monthC) + "个月前";
        } else if (weekC >= 1) {
          res = parseInt(weekC) + "周前";
        } else if (dayC >= 1) {
          res = parseInt(dayC) + "天前";
        } else if (hourC >= 1) {
          res = parseInt(hourC) + "个小时前";
        } else if (minC >= 1) {
          res = parseInt(minC) + "分钟前";
        } else {
          res = "刚刚";
        }
        return res;
      };
    }
  },
  methods: {
    /**
     * 获取客户详情
     */
    getCustomerDetails(id) {
      getCustomerDetails({ client_id: id }).then(res => {
        this.liList = res.data;
        console.log(this.liList);
      });
    },
    copy() {
      var clipboard = new this.Clipboard(".tag-read");
      clipboard.on("success", e => {
        Toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        Toast("复制失败");
        // 释放内存
        clipboard.destroy();
      });
    },
    getNumberViewsTodayNew() {
      getNumberViewsTodayNew().then(res => {
        this.numberViewsToday = res.data;
      });
    },
    // 获取客户线索列表
    getClientListNew() {
      var data = "?limit=30&page=" + this.page;
      getClientListNew(data).then(res => {
        this.clientList = res.data;
      });
    },
    gouserinfo(id) {
      return this.$router.push({ path: "/kehu/kehuinfo" });
    },
    //跳转
    gopage(type) {
      if (type == "tixing") {
        console.log(1);
        return this.$router.push({ path: "/kehu/setMessageReminder" });
      }
    },

    setOpenShare() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: "https://jdbeautycm.congwa.xyz",
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>

<style></style>
